import * as React from "react";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";

const settings = {
  width: 200,
  height: 200,

};

export default function ArcDesign({ value, text }) {
  return (
    <Gauge
      {...settings}
      cornerRadius="50%"
      value={value}
      valueMax={100}
      innerRadius="60%"
      text={({ value }) => `${value}%\n ${text}`}
      outerRadius="99%"
      sx={() => ({
        [`& .${gaugeClasses.valueText} text`]: {
          fontSize: 12,
          fontWeight:"bold",
          fill:"#fff"
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: "#fff",
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: "#FFFFFF80",
        },
      })}
    />

  );
}
